









































import {
  computed,
  defineComponent,
  ref,
  vue3Model,
  watch
} from '~/utils/nuxt3-migration'
import CFormGroup from '~/components/shared/configurable/form/CFormGroup.vue'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import { debounce } from '~/utils/function'
import { DEBOUNCE_SLOW } from '~/constants/debounce'
import CInput from '~/components/shared/configurable/form/input/CInput.vue'
import CClassifiedMakeCustomSelect from '~/components/shared/configurable/classified/CClassifiedMakeCustomSelect.vue'
import { useI18n } from '~/compositions/i18n'

export default defineComponent({
  model: vue3Model,
  components: {
    CClassifiedMakeCustomSelect,
    CFormGroup,
    CCustomSelect,
    CInput
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n()

    const facet = ref(props.modelValue)
    const selectedMakes = ref(facet.value?.values?.selected?.makes || [])
    const selectedModels = ref(facet.value?.values?.selected?.models || [])
    const variant = ref(facet.value?.values?.selected?.variant || '')

    watch(
      () => props.modelValue,
      (newValue: any) => {
        facet.value = {
          ...facet.value,
          ...newValue
        }

        selectedMakes.value = facet.value?.values?.selected?.makes || []
        selectedModels.value = facet.value?.values?.selected?.models || []
        variant.value = facet.value?.values?.selected?.variant || ''
      }
    )

    const makeLogoType = computed(() => {
      return facet.value.inBikesSearch ? 'bikes' : 'cars'
    })

    const topMakesOptions = computed(() =>
      (facet.value.searchables || [])
        .filter((make: any) => make.isTop)
        .map((item: any) => {
          return {
            value: item.v,
            label: item.n,
            count: item.c
          }
        })
    )

    const makesOptions = computed(() =>
      (facet.value.searchables || []).map((item: any) => {
        return {
          value: item.v,
          label: item.n,
          count: item.c
        }
      })
    )

    const modelsOptionGroups = computed(() => {
      if (selectedMakes.value.length === 0) {
        return []
      }

      return (facet.value.searchables || [])
        .filter(make => make.s)
        .map(make => {
          return {
            label: make.n,
            options: make.k
              ? make.k.flatMap(model => {
                  const flatSeriesAndModels = [
                    {
                      value: model.v,
                      label: model.n,
                      count: model.c
                    },
                    model.k
                      ? model.k.map(model => {
                          return {
                            value: model.v,
                            label: model.n,
                            count: model.c,
                            belongsToASeries: true
                          }
                        })
                      : []
                  ]
                  return [].concat(...flatSeriesAndModels)
                })
              : []
          }
        })
        .filter(group => group.options.length > 0)
    })

    const showModel = computed(() => facet.value.showModel || false)

    const showVariant = computed(() => facet.value.showVariant || false)

    const selectedMakeHasModels = computed(
      () => selectedMakes.value.length && modelsOptionGroups.value.length
    )

    const modelPlaceholder = computed(() => {
      if (selectedMakes.value.length) {
        return selectedMakeHasModels.value ? t('model') : t('no models found')
      }

      return t('model')
    })

    const emitMakeChange = debounce((newValue: any) => {
      emit('update:modelValue', {
        name: facet.value.urlargNames[0],
        value: newValue
      })
    }, DEBOUNCE_SLOW)

    const emitModelChange = debounce((newValue: any) => {
      emit('update:modelValue', {
        name: facet.value.urlargNames[1],
        value: newValue
      })
    }, DEBOUNCE_SLOW)

    const emitVariantChange = debounce(() => {
      emit('update:modelValue', {
        name: facet.value.variant.urlargNames[0],
        value: variant.value
      })
    }, DEBOUNCE_SLOW)

    function handleMakeChange(newValue: any) {
      emitMakeChange(newValue)
    }

    function handleModelChange(newValue: any) {
      emitModelChange(newValue)
    }

    function handleVariant() {
      emitVariantChange()
    }

    return {
      facet,
      selectedMakes,
      selectedModels,
      variant,
      topMakesOptions,
      makeLogoType,
      makesOptions,
      modelsOptionGroups,
      showModel,
      showVariant,
      selectedMakeHasModels,
      modelPlaceholder,
      handleVariant,
      handleMakeChange,
      handleModelChange
    }
  }
})
